import { Navigate, useLocation } from "react-router-dom"
import { useSession } from "source/shared/hooks/useSession"
import ConfirmationLayout from "../../components/ConfirmationLayout"
import { PostDonateStatus } from "../form/components/PostDonateStatus"

export function DonationProcessing() {
  const {
    data: {
      attributes: { first_name },
    },
  } = useSession()

  const { state } = useLocation()

  if (!state) {
    console.debug(
      "[DonationForm] missing navigation state for processing page, redirecting to form",
    )
    return <Navigate to="/giving/" replace />
  }

  const { nondeterministicError } = state

  const { heading, message } = nondeterministicError
    ? {
        heading: "Donation processing",
        message:
          "Your donation has been received, and we’ll email a receipt when processing is complete.",
      }
    : {
        heading: `Thank you, ${first_name}!`,
        message:
          "Your donation is processing, and we’ll email a receipt for your records.",
      }

  return (
    <ConfirmationLayout>
      <PostDonateStatus
        status="processing"
        heading={heading}
        message={message}
      />
    </ConfirmationLayout>
  )
}
